import React, { useContext } from 'react';
import { List, ListItem, makeStyles } from '@material-ui/core';
import AppointmentCard from '../Card/Card';
import PropTypes from 'prop-types';
// import OPTION_ICON from '../../../assets/images/3-dots.png';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import MessagesContext from '../../../contexts/messagesContext';
import useCheckAccess from '../../../hooks/useCheckAccess';

const withStyles = makeStyles(() => ({
    columnContainer: {
        position: 'relative',
        // paddingTop: '16px',
        paddingBottom: '2px',
        backgroundColor: '#fff',
        height: '100%',
        borderRadius: '10px'
    },
    rootList: {
        margin: '0',
        // width: '270px',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto'
    },
    draggingOverRootList: {
        background: '#e7e9ec'
    },
    dragOutOfList: {
        // opacity: '.9'
    },
    listHeader: {
        backgroundImage: 'linear-gradient(81deg, #509ffa -12%, #416ce1 99%)',
        color: 'white',
        borderRadius: '10px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
        fontFamily: 'inherit',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '13px 16px',
        position: 'absolute',
        top: '-56px',
        left: '0',
        right: '0',
        zIndex: '2',
        '& >span:last-child': {
            padding: '0px 8px',
            borderRadius: '4px',
            backdropFilter: 'blur(10px)',
            border: 'solid 0.5px rgba(255, 255, 255, 0.2)',
            backgroundImage:
                'linear-gradient(222deg, rgba(255, 255, 255, 0.4) 94%, rgba(255, 255, 255, 0.2) 3%)'
        }
    },
    optionIcon: {
        width: '24px',
        height: '24px',
        cursor: 'pointer'
    },
    listItemRoot: {
        opacity: 1,
        padding: '0'
        // textAlign: 'right'
    },
    dragOutOfListItem: {
        opacity: '0.5'
    }
}));
export default function AppointmentList(props) {
    const { isAppointmentInPatients } = props;
    const classes = withStyles({ isAppointmentInPatients });
    const { messages } = useContext(MessagesContext);
    const { notEditDemographic } = useCheckAccess();

    return (
        <div className={classes.columnContainer}>
            <div className={classes.listHeader}>
                <span>{messages[props.section?.label]}</span>&nbsp;
                <span>{props.appointments?.length ? props.appointments?.length : 0}</span>
            </div>
            <Droppable droppableId={props.section?.id}>
                {(provided, snapshot) => (
                    <List
                        innerRef={provided.innerRef}
                        key={props.section?.id}
                        {...provided.droppableProps}
                        className={`
                       ${snapshot.isDraggingOver ? classes.draggingOverRootList : ''}
                       ${classes.rootList}
                       ${
                           props.draggingSource &&
                           snapshot.isDraggingOver &&
                           props.draggingSource !== props.section?.id
                               ? classes.dragOutOfList
                               : ''
                       }
                    `}
                        // subheader={
                        //     <ListSubheader className={classes.listHeader}>
                        //         <div>
                        //             {props.section?.label} ({props.appointments?.length})
                        //         </div>
                        //         <img
                        //             className={classes.optionIcon}
                        //             src={OPTION_ICON}
                        //             alt="options"
                        //         />{' '}
                        //     </ListSubheader>
                        // }
                    >
                        {props.appointments?.map((appointment, key) => (
                            <Draggable
                                key={appointment?.id}
                                draggableId={appointment?.id.toString()}
                                index={key}
                                isDragDisabled={notEditDemographic}
                            >
                                {(provided, dragSnapshot) => (
                                    <ListItem
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        innerRef={provided.innerRef}
                                        className={`${classes.listItemRoot} ${
                                            props.draggingSource &&
                                            snapshot.isDraggingOver &&
                                            props.draggingSource !== props.section?.id &&
                                            classes.dragOutOfListItem
                                        }`}
                                    >
                                        <AppointmentCard
                                            isDragging={dragSnapshot.isDragging}
                                            appointment={appointment}
                                            index={key}
                                        />
                                    </ListItem>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </List>
                )}
            </Droppable>
        </div>
    );
}
AppointmentList.propTypes = {
    section: PropTypes.object.isRequired,
    appointments: PropTypes.array,
    draggingSource: PropTypes.string,
    isAppointmentInPatients: PropTypes.bool
};
